// eslint-disable-next-line import/prefer-default-export
export const PREFECTURES = ["福岡県", "佐賀県", "長崎県", "熊本県", "大分県", "宮崎県", "鹿児島県"];
